import axios from "axios";
import {API_URL_AUTH} from "@/api/urls";
import {refreshJwt} from "@/api/authApi";
import {appendSendVia} from "utils/appendSendVia";

window.axios = axios;

axios.interceptors.request.use((config) => {
  const url = config.url || "";
  const body = config.data?.requestBodyDto;
  if (!body) return config;

  if (url.includes("request/v1/create") && body.requestMessage != null) {
    body.requestMessage = appendSendVia(body.requestMessage);
  }
  if (url.includes("franchising/request/v1/create") && body.requestInterest != null) {
    body.requestInterest = appendSendVia(body.requestInterest);
  }

  return config;
});

export const setAuthorizationToken = (token) => {
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};

export const removeAuthorizationToken = () => {
  axios.defaults.headers.common["Authorization"] = ``;
}

export const setupInterceptors = (store) => {
  let requestsToRefresh = [];

  let isRefreshRequesting = false;

  axios.interceptors.response.use(
    (response) => {
      return response;
    },

    async (err) => {
      const { response, config } = err;
      if (response?.status === 401) {
        if (!store.isLogined) {
          return Promise.reject(err);
        }

        if (response.config.url === API_URL_AUTH + "jwt/refresh") {
          store.logout();
        }

        if (!isRefreshRequesting) {
          isRefreshRequesting = true;

          // setAuthorizationToken(store.user.refreshJwt);

          refreshJwt(
            {
              expiredJwt: store.user.jwt,
              refreshJwt: store.user.refreshJwt,
            },
            store.user.userLogin,
            store.user.refreshJwt
          )
            .then((user) => {
              store.setUser(user);

              requestsToRefresh.forEach((cb) => cb(user.jwt));
            })

            .catch(() => {
              store.logout();
            })

            .finally(() => {
              requestsToRefresh = [];
              isRefreshRequesting = false;
            });
        }

        return new Promise((resolve, reject) => {
          requestsToRefresh.push((token) => {
            if (token) {
              config.headers.Authorization = "Bearer " + token;
              resolve(axios(config));
            }

            reject(err);
          });
        });
      }
      if (err.response?.data) {
        const error = err.response.data.errors
          ? err.response.data.errors[0]
          : err.response.data.error;
        return Promise.reject({
          ...err.response.data,
          message: error ? error.errorMsg || error : err.response.data.message,
        });
      }
      return Promise.reject(err);
    }
  );
};

// ====================================================

// ====================================================

// ====================================================

// Debigging
// axios.interceptors.request.use(
//   (config) => {
//     console.log(config);
//     return config;
//   },

//   (error) => {
//     console.log(error);
//     return error;
//   }
// );
